module.exports = __webpack_public_path__ + "static/media/loggly-logo.de204f53.svg";